import { SlideOverHeader } from '@/components/slideOvers_v2';
import { DataSourceIcon } from '@/lib';
import { FC, ReactNode } from 'react';

interface IDataSourceTypePanelHeaderProps {
  id: string;
  title?: string;
  subtitle?: ReactNode;
}

const DataSourceTypePanelHeaderV2: FC<IDataSourceTypePanelHeaderProps> = ({ title, id, subtitle }) => {
  return <SlideOverHeader icon={<DataSourceIcon type={id} className='size-16' />} title={title ?? ''} subtitle={subtitle} />;
};

export default DataSourceTypePanelHeaderV2;
